import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Form } from "antd";
import { useFormService, useI18n } from "../../../../../contexts";
import { Notices } from "../../../../common";
const FormServiceFieldHandlingSkipIfActiveNotice = (param)=>{
    let { name } = param;
    const { __, _i } = useI18n();
    const { skipIfActiveComponents } = useFormService();
    const componentKeys = useMemo(()=>Object.keys(skipIfActiveComponents), [
        skipIfActiveComponents
    ]);
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues[name] !== nextValues[name],
        children: (param)=>{
            let { getFieldValue } = param;
            const value = getFieldValue(name);
            // Find `skip-if-active` and their active components
            const matches = [
                ...value.matchAll(/\s+(skip-if-active=")([^"]+)(")/gm)
            ].map((param)=>{
                let [, , components] = param;
                return components.split(",").filter((plugin)=>componentKeys.indexOf(plugin) > -1);
            }).flat();
            const uniq = matches.filter((plugin, i)=>matches.indexOf(plugin) === i);
            if (uniq.length === 0) {
                return null;
            }
            return /*#__PURE__*/ _jsx("div", {
                style: {
                    marginTop: 10
                },
                children: /*#__PURE__*/ _jsx(Notices, {
                    notices: [
                        {
                            message: _i(__("The code above contains HTML tags that are skipped when one of the following plugins is active: {{strong/}}. {{i}}What does this mean for me?{{/i}} In most cases, another plugin will take over the execution of the technical code, and you have to create a corresponding content blocker."), {
                                strong: /*#__PURE__*/ _jsx("strong", {
                                    children: uniq.map((plugin)=>skipIfActiveComponents[plugin]).join(", ")
                                }),
                                i: /*#__PURE__*/ _jsx("i", {})
                            }),
                            severity: "info"
                        }
                    ]
                })
            });
        }
    });
};
export { FormServiceFieldHandlingSkipIfActiveNotice };
